export default "__VITE_ASSET__BsWUz0Ii__"